import { Card, Group, Stack, Text, Tooltip, UnstyledButton } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import AnimatedNumber from '@/components/Dashboard/AnimatedNumber';
import { SvgChatProps, SvgInfo } from '@/components/Dashboard/icon';

export interface OverviewCardProps extends Omit<React.ButtonHTMLAttributes<HTMLDivElement>, 'title'> {
  id: string;
  icon: React.FC<SvgChatProps>;
  value: number;
  time: string;
  valueUnit?: string;
  title: string;
  tip?: string;
}

const OverviewCard: React.FC<OverviewCardProps> = ({ icon, time, tip, title, value, valueUnit, ...props }) => {
  const { t } = useTranslation();

  const Icon = icon;
  return (
    <Card
      shadow="sm"
      p="lg"
      radius="md"
      className="group transform transition-transform duration-300 hover:shadow-md cursor-pointer"
      {...props}
    >
      <Group className="flex" justify="space-between" wrap="nowrap">
        <Stack className="flex-auto flex items-start">
          <Group className="flex items-center" wrap="nowrap" gap={8}>
            <Icon className="transform transition-transform duration-300 group-hover:rotate-12" />
            <Group gap={5} wrap="nowrap">
              <Text className="text-gray-900" lh={1.2}>
                {title}
              </Text>
              {tip && (
                <Tooltip label={tip} withinPortal multiline w={220}>
                  <span>
                    <SvgInfo />
                  </span>
                </Tooltip>
              )}
            </Group>
          </Group>
          <UnstyledButton className="flex items-center space-x-2 text-gray-500 hover:text-gray-600 focus:outline-none transform transition-transform duration-300 group-hover:translate-x-2">
            <Text size="sm" c={'violet.5'}>
              {t('dashboard.details')} {'->'}
            </Text>
          </UnstyledButton>
        </Stack>
        <Stack align="center" className="flex-none text-right mx-2">
          <Text className="text-xl text-gray-900">
            <AnimatedNumber targetValue={value} />
            {valueUnit}
          </Text>
          <Text className="text-sm text-[#98A2B3]">{time}</Text>
        </Stack>
      </Group>
    </Card>
  );
};

export default OverviewCard;
